import { PATCH_DATA } from '../actions';

export default function recordReducer(record={id:0, sections:[], data: {}}, action) {
    switch (action.type)
    {
        case 'LOAD_RECORD':
            return action.record;
        case PATCH_DATA:
            return {
                ...record,
                data: {
                    ...record.data,
                    ...action.data
                }
            };
        default:
            break;
    };
    return record;
}